const url = new URL(window.location.href);
const checkoutUrl = url.searchParams.get('checkout_url');
const redirectAfterLogin = localStorage.getItem('redirect_after_login');
const tab = url.searchParams.get('tab');
// loads config from wd-scripts
const config = window.wdStoreRedirectionsConfig || {};

/** True when target URL is the same page we are already on (avoids a pointless reload). */
function isSamePageNavigation(targetHref) {
    try {
        const target = new URL(targetHref, window.location.origin);
        const current = new URL(window.location.href);
        return target.origin === current.origin
            && target.pathname === current.pathname
            && target.search === current.search;
    } catch (_) {
        return false;
    }
}

if (config.shouldRedirectToAccount && !window.location.href.includes('/account')) {
    window.location.href = '/account';
}
if (checkoutUrl && !window.location.href.includes('/account/login')) {
    window.location.href = checkoutUrl;
}
if (redirectAfterLogin && config.doneRegister && !config.shouldRedirectToAccount) {
    localStorage.removeItem('redirect_after_login');
    if (tab !== 'club' && !isSamePageNavigation(redirectAfterLogin)) {
        window.location.href = redirectAfterLogin;
    }
}
if (config.shouldInterceptAccountLink) {
    document.addEventListener('DOMContentLoaded', function () {
        const accountLink = document.querySelector('.header__icon--account.link');
        if (accountLink && !window.location.href.includes('/account/login') && !window.location.href.includes('/account/register')) {
            accountLink.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                localStorage.setItem('redirect_after_login', window.location.pathname != "/" ? window.location.href : `https://${window.location.host}/account`);
                window.location.href = '/account';
            });
        }
    });
}
if(window.location.pathname.toLowerCase().startsWith("/en")){
    window.location.href = window.location.href.replace("/en", "");
}
